'use strict';

const debounce = require('lodash/debounce');

const SEARCH_DEBOUNCE_MILLISECONDS = 300;
// Below this, a full-text search over the whole FAQ taxonomy matches almost
// everything, so typing keeps showing the page's own content instead.
const MINIMUM_QUERY_LENGTH = 3;

module.exports = function initFaqSearchBar() {
	const $form = $('.faq-search-bar');

	if (!$form.length) {
		return;
	}

	const $input = $form.find('.faq-search-bar__input');
	const $clearButton = $form.find('.faq-search-bar__clear');
	const $searchResults = $('[data-faq-search-results]');
	const $staticContent = $('[data-faq-static-content]');
	const initialResultsMarkup = $searchResults.html();
	const searchUrl = $form.attr('action');
	const hubUrl = $form.data('faqHubUrl');
	let pendingSearchRequest = null;

	function abortPendingSearch() {
		if (pendingSearchRequest) {
			pendingSearchRequest.abort();
			pendingSearchRequest = null;
		}
	}

	function runSearch(query) {
		// An earlier keystroke still in flight would otherwise overwrite the
		// results of a later, narrower one.
		abortPendingSearch();

		const parameterSeparator = searchUrl.indexOf('?') === -1 ? '?' : '&';

		$searchResults.attr('aria-busy', 'true');

		pendingSearchRequest = $.ajax({
			url: searchUrl + parameterSeparator + $.param({ q: query, ajax: true }),
			type: 'get',
			dataType: 'html'
		})
			.done(function replaceResults(resultsMarkup) {
				$searchResults.html(resultsMarkup);
				$staticContent.prop('hidden', true);
			})
			.always(function clearPendingState() {
				pendingSearchRequest = null;
				$searchResults.attr('aria-busy', 'false');
			});
	}

	const updateResults = debounce(function updateResultsForCurrentQuery() {
		const query = $input.val().trim();

		if (query.length < MINIMUM_QUERY_LENGTH) {
			abortPendingSearch();
			$searchResults.html(initialResultsMarkup);
			$staticContent.prop('hidden', false);
			return;
		}

		runSearch(query);
	}, SEARCH_DEBOUNCE_MILLISECONDS);

	$input.on('input', function searchWhileTyping() {
		$clearButton.prop('hidden', this.value.length === 0);
		updateResults();
	});

	$clearButton.on('click', function clearSearchField() {
		updateResults.cancel();
		abortPendingSearch();

		// The dedicated FAQ-Search page has no static content to fall back to —
		// initialResultsMarkup there is itself a search result, not an empty
		// state — so clearing navigates to the hub instead of re-showing it.
		if (!$staticContent.length && hubUrl) {
			window.location.href = hubUrl;
			return;
		}

		$input.val('').trigger('focus');
		$clearButton.prop('hidden', true);
		$searchResults.html(initialResultsMarkup);
		$staticContent.prop('hidden', false);
	});
};
